import React from "react";

export default function SessionConflictModal({ open, onLogout }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-xl shadow-xl p-6 w-[400px] text-center">
        <h2 className="text-xl font-bold text-red-600 mb-3">
          Session Conflict Detected
        </h2>

        <p className="text-gray-600 mb-5">
          Same user is already logged in another browser or window.
        </p>

        <button
          onClick={onLogout}
          className="bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-lg"
        >
          Logout
        </button>
      </div>
    </div>
  );
}